import React from 'react';
import PropTypes from 'prop-types';
import MaxWidthContainer from '../Containers/MaxWidthContainer';

const GradHero = ({ children }) => (
  <div className="grad-hero hero hero--m bg-grad-green-blue color-white">
    <MaxWidthContainer>
      {children}
    </MaxWidthContainer>
  </div>
);

GradHero.propTypes = {
  children: PropTypes.object.isRequired,
};

export default GradHero;



// WEBPACK FOOTER //
// ./library/app/components/Global/Heros/GradHero.js